import swal from 'sweetalert2'
import { API } from 'services/API'
import * as Alert from "alertService"

export const InputPassword = (method, URL, dataForSend, title, text, callback) => {
    swal({
        title: title,
        text: text + "\n ใส่รหัสผ่านของคุณเพื่อยืนยันการทำงานนี้",
        input: 'password',
        inputAttributes: {
            autocapitalize: 'off'
        },
        showCancelButton: true,
        focusConfirm: false,
        cancelButtonText: "ปิด",
        cancelButtonColor: "#9575CD",
        confirmButtonText: 'ยืนยัน',
        confirmButtonColor: "#03A9F4",
        preConfirm: (password) => {
            dataForSend.Password = password
            Alert.Loading()
            return API(method, URL, dataForSend, (datas) => {
                callback(datas)
            })
        }
    })
}